import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute} from '@angular/router';
import {LetterV2} from 'src/app/models/letter-v2';
import {EventService} from 'src/app/services/event.service';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {SnackBarIconService} from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import {LettersSpeakersDialogComponent} from '../dialogs/letters-speakers-dialog/letters-speakers-dialog.component';
import {LettersSpeakersPreviewDialogComponent} from '../dialogs/letters-speakers-preview-dialog/letters-speakers-preview-dialog.component';
import {InviteSpeakersService} from 'src/app/services/invite-speakers.service';
import {LetterSpeakersService} from 'src/app/services/letter-speakers.service';
import {InviteSpeakersDialogComponent} from '../dialogs/invite-speakers-dialog/invite-speakers-dialog.component';
import {MemberService} from 'src/app/services/member.service';
import {SpeakerMemberDataDialogComponent} from '../dialogs/speaker-member-data-dialog/speaker-member-data-dialog.component';
import {ContextService} from 'src/app/services/context.service';
import {SpinnerService} from 'src/app/shared/waiting/spinner.service';

@Component({
  selector: 'app-letters-speakers',
  templateUrl: './letters-speakers.component.html',
  styleUrls: [ './letters-speakers.component.scss' ]
})
export class LettersSpeakersComponent implements OnInit {

  public events: any[];
  public waiting: any;
  public isCongress: boolean;
  public uid: string;
  public title: any;

  public letterSelected: LetterV2;
  public staffDataSource: MatTableDataSource<any>

  public master: any;
  public event: any;

  constructor (
    private _activeRoute: ActivatedRoute,
    private _dialog: MatDialog,
    public _eventService: EventService,
    public _letterSpeakersService: LetterSpeakersService,
    public _memberService: MemberService,
    private _snackBar: SnackBarIconService,
    public _inviteSpeakersService: InviteSpeakersService,
    private _contextService: ContextService,
    private _spinnerService: SpinnerService
  ) { }

  ngOnInit () {
    this._activeRoute.params.subscribe(params => {
      this.isCongress = params[ 'isCongress' ] === 'true';
      this.uid = params[ 'uid' ];
      // console.log("isCongress: " + this.isCongress)
      // console.log("uid: " + this.uid)

      this.selectContext()

    })
  }

  async selectContext () {

    if (this.isCongress) {
      this.master = await this._contextService.getMasterEvent(this.uid);
      this.title = this.master.name;
      this._letterSpeakersService.loadLettersByContext(this.uid)
    } else {
      this.event = await this._contextService.getEvent(this.uid);
      // console.log("selectContext event: " + JSON.stringify(this.event))
      this.title = this.event.name;
      this._letterSpeakersService.loadLettersByEvent(this.uid)
    }

    this.events = await this._contextService.getEventsInContext(this.isCongress, this.uid);
    this._inviteSpeakersService.invitesDataSource = null;
    this.loadResponses()
  }

  async letterSpeakerSelectChange (letter: any) {
    this.letterSelected = letter
    //const events = await this._contextService.getEventsInContext(this.isCongress, this.uid);
    const agendaRaw = await this._inviteSpeakersService.getAgenda(this.events);
    const agenda = await this._inviteSpeakersService.formatAgenda(agendaRaw);
    const agendaByMembers = await this._inviteSpeakersService.groupByMemberId(agenda);
    await this._inviteSpeakersService.loadAndCheckInvitesSent(this.uid, this.letterSelected.id, agendaByMembers)
  }

  openLetterDialog (entity: any) {

    let data: LetterV2 = new LetterV2();

    if (entity) {
      data = entity;
    }

    let event: any;
    if (this.isCongress) {
      event = this.master;
    } else {
      event = this.event;
    }

    // console.log("openLetterDialog event: " + JSON.stringify(event))
    
    this._dialog.open(LettersSpeakersDialogComponent, {
      width: '820px',
      height: '680px',
      panelClass: 'custom-dialog-container',
      data: {'letter': data, 'event': event, "isCongress": this.isCongress}
    });
  }

  openInviteDialog (invite) {

    let data: any = {};
    data.letter = this.letterSelected
    // console.log(JSON.stringify(data.letter))

    if (invite) {
      data.invite = invite;
    } else {
      data.invite = {};
    }

    let dialogRef = this._dialog.open(InviteSpeakersDialogComponent, {
      width: '860px',
      height: '680px',
      panelClass: 'custom-dialog-container',
      data: data
    });

    dialogRef.afterClosed().subscribe(async (response) => {

      const action: any = response[ 0 ]

      if (action == 'response') {

        const invite: any = response[ 1 ]

        let acceptAll: boolean = false
        let countRejection: number = 0;

        invite.agenda.forEach(item => {
          // console.log("item: " + JSON.stringify(item.acceptInvite))
          if (!item.acceptInvite) {
            countRejection++
          }
        });

        if (countRejection == 0) {
          acceptAll = true
        } else {
          acceptAll = false
        }

        const updatedData: any = {
          'accept': acceptAll,
          'date_response': new Date(),
          'admin_response': true,
          'agenda': invite.agenda,
          'obs': ''
        }

        // console.log("invite.id: " + invite.invite_id)
        // console.log("updatedData :" + JSON.stringify(updatedData))

        this._inviteSpeakersService.registerResponse(invite.invite_id, updatedData)
          .then(() => {
          })
          .catch((err) => {
            console.log("erro")
          })

      }

      if (action == 'invite') {

        const invite: any = response[ 1 ]

        let data: any;
        if (this.isCongress) {
          //const masterEvent = await this._inviteSpeakersService.getMasterEvent(this.uid)
          //console.log(JSON.stringify(masterEvent))
          data = {
            "invite": invite,
            "context_id": this.uid,
            "letter": this.letterSelected,
          }
        } else {
          data = {
            "letter": this.letterSelected,
            "context_id": this.uid,
            "invite": invite,
          }
        }
        //console.log("invite data sem email: " + JSON.stringify(data))
        this._inviteSpeakersService.registerInvite(data, false, "", true) //data, email(s/n), obs, admin_invite
          .then((invite) => {
            console.log("registerInvite: " + invite)
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((error) => {
            console.log("ERRO:: " + JSON.stringify(error.message));
            this._snackBar.openSnackBar("Erro!", '', 'error')
          })

      }

    })

  }

  openPreviewDialog (entity) {

    //console.log("openPreviewDialog entity: " + JSON.stringify(entity))

    let letter: LetterV2 = entity;

    this._dialog.open(LettersSpeakersPreviewDialogComponent, {
      width: '980px',
      height: '700px',
      panelClass: 'custom-dialog-container',
      data: {'letter': letter, 'event': this._eventService.currentEvent}
    });

  }

  makeShipping () {

    this._inviteSpeakersService.makeShipping(
      this._inviteSpeakersService.invitesDataSource.data,
      this.letterSelected,
      this.uid
    )

  }

  loadResponses () {
    const event_id = this.uid
    this._inviteSpeakersService.selectInvites(event_id)
      .subscribe((result) => {

        let members: any = [];
        let member: any = "";
        let letters: any = [];

        const membersActive: any = []
        const membersArchived: any[] = []

        result.forEach((item) => {

          let ltr: any = {};
          ltr = item.data();
          ltr.id = item.id
          letters.push(ltr);


          if (member != item.data().member_name) {
            member = item.data().member_name

            let url_update: string = item.data().url_back
            url_update = url_update.replace("confirm", "update")
            url_update = url_update + ":true"

            // console.log(item.payload.doc.data().member_name)
            // console.log(url_confirm)
            // console.log("------------------------")

            members.push(
              {
                'id': item.data().member_id,
                'name': item.data().member_name,
                'url_update': url_update
              }
            )
          }
        })

        members.forEach((item) => {

          const lettersActive: any[] = []
          const lettersArchived: any[] = []

          let allLettersMember = letters.filter((e) => {
            return e.member_id == item.id
          })

          allLettersMember.forEach((letter) => {
            if (letter.archived) {
              lettersArchived.push(letter)
            } else {
              lettersActive.push(letter)
            }
          })

          // item.letters = allLettersMember;

          if (lettersArchived.length > 0) {
            membersArchived.push({...item, 'letters': lettersArchived})
          }
          if (lettersActive.length > 0) {
            membersActive.push({...item, 'letters': lettersActive})
          }
        })

        //console.log("lettersActive: " + JSON.stringify(membersActive))
        this._inviteSpeakersService.responsesDataSource = new MatTableDataSource(membersActive);
        this._inviteSpeakersService.responsesArchivedDataSource = new MatTableDataSource(membersArchived);

      })

  }

  changeAllLetters (event) {
    this._inviteSpeakersService.invitesDataSource.data.forEach((item) => {
      item.selected = event.checked
    })
  }

  deleteLetter (element) {
    let id = element.id;

    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir esta carta?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {

        //console.log("deleteLetter id: " + id);

        this._letterSpeakersService.delete(id)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch((err: any) => {
            console.log("delete invite error: " + err.message)
          });
      }
    })

  }

  deleteInvite (invite) {

    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '400px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme apagar", message: invite.member_name + "<br><br>" + this.letterSelected.name + "<br><br>APAGAR este convite?"}
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        // console.log("invite: " + invite.invite_id)
        this._inviteSpeakersService.delete(invite.invite_id)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success')
          })
          .catch(
            (error) => {console.log("delete invite error: " + error.message)}
          )
      }

    })

  }

  toggleCheckStaff (checked) {
    //   console.log("checked: " + JSON.stringify(checked))

    this.staffDataSource.data.forEach((item) => {
      item.selected = checked;
    })

  }

  archiveItem (element) {
    const id = element.id
    const flag: boolean = element.archived ? true : false
    let text: string;

    if (flag) {
      text = 'desarquivar'
    } else {
      text = 'arquivar'
    }

    let dialogRef = this._dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: "<br>Deseja " + text + " este convite?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._inviteSpeakersService.archiveInvite(id, flag)
          .then(() => {
            this._snackBar.openSnackBar("Sucesso!", '', 'success');
          })
          .catch((err) => {
            console.log('erro')
          })
      }
    })
  }

  openMemberDataDialog (element) {
    // console.log("element: " + JSON.stringify(element))

    let invites: any[] = []

    element.letters.forEach(invite => {

      invites.push({
        'invite_id': invite.id,
        'memberDataCheck': invite.memberDataCheck
      })
    });

    //   console.log("letters: " + JSON.stringify(letters))

    this._memberService.getById(element.id)
      .subscribe((result) => {
        const memberData: any = {
          "id": result.id,
          "data": result.data(),
          "urlUpdate": element.url_update,
          'invites': invites
        }

        let dialogRef = this._dialog.open(SpeakerMemberDataDialogComponent, {
          width: '600px',
          height: '580px',
          panelClass: 'custom-dialog-container',
          data: memberData
        });

      })

  }

}
